var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircularLoaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_780_42558_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.012 0 0 0.012 12 12)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1083.33,
    y: -1083.33,
    width: 2166.67,
    height: 2166.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(0, 0, 0, 0.8) 0deg,rgba(18, 131, 112, 0) 0.036deg,rgba(0, 118, 114, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.80000001192092896},\"position\":0.0},{\"color\":{\"r\":0.070588238537311554,\"g\":0.51372551918029785,\"b\":0.43921568989753723,\"a\":0.0},\"position\":9.9999997473787516e-05},{\"color\":{\"r\":0.0,\"g\":0.46274510025978088,\"b\":0.44705882668495178,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.80000001192092896},\"position\":0.0},{\"color\":{\"r\":0.070588238537311554,\"g\":0.51372551918029785,\"b\":0.43921568989753723,\"a\":0.0},\"position\":9.9999997473787516e-05},{\"color\":{\"r\":0.0,\"g\":0.46274510025978088,\"b\":0.44705882668495178,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":24.0,\"m01\":2.2785857131234905e-14,\"m02\":-2.1316282072803006e-14,\"m10\":-1.2127716941866349e-14,\"m11\":24.0,\"m12\":-5.3290705182007514e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7823 9.60062C23.3301 9.52995 23.8314 9.91669 23.902 10.4644C23.9677 10.9736 24.0007 11.4865 24.0007 11.9999C24.0007 12.5522 23.553 12.9999 23.0007 12.9999C22.4484 12.9999 22.0007 12.5522 22.0007 11.9999C22.0007 11.5721 21.9732 11.1447 21.9185 10.7204C21.8478 10.1726 22.2346 9.67128 22.7823 9.60062Z",
    fill: "#007672"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_780_42558_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularLoaderIcon);
export default __webpack_public_path__ + "static/media/circular-loader-icon.c1da9097877edcd3cdaf4afa8664abb6.svg";
export { ForwardRef as ReactComponent };